import type { QueryClient, InfiniteData } from '@tanstack/react-query';
import type { PaginatedPostsV2, PostV2 } from '@/components/v2/community/types';

/** Finds the feed card currently visible for a post without issuing a request. */
export function findCommunityPostPreview(
  queryClient: QueryClient,
  postId: string
): PostV2 | undefined {
  const feeds = queryClient.getQueriesData<InfiniteData<PaginatedPostsV2>>({
    queryKey: ['community-posts'],
  });

  for (const [, feed] of feeds) {
    const post = feed?.pages
      .flatMap((page) => page.data)
      .find((candidate) => candidate.id === postId);
    if (post) return post;
  }

  return undefined;
}
